import { useTranslation } from 'react-i18next'
import { ShieldCheckIcon } from '@/ui/icons/shield-check'

export const WfpBanner = () => {
  const { t } = useTranslation()

  return (
    <div className="flex w-full items-start gap-2 rounded-lg bg-white p-3">
      <ShieldCheckIcon className="size-4 shrink-0 text-neutral-950" />
      <div className="flex flex-col">
        <p className="text-xs font-normal text-neutral-950">
          {t('initial_selection.wfp_banner_title')}
        </p>
        <p className="text-xs font-normal text-neutral-500">
          {t('initial_selection.wfp_banner_description')}
        </p>
      </div>
    </div>
  )
}
